import React from "react";

export default function MySQL_SUBTIME() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SUBTIME</h1>
      <p>This is the MySQL_SUBTIME component generated from the SQL JSON.</p>
    </div>
  );
}
